import React, { useEffect, useState } from "react";
import DisplayChartv2 from "./DisplayChartv2";
import Select from "react-select";
import { getTrialVideos } from "../../util/trialApi";
function VideoChartContainer(props) {
  const [videoMetaData, setVideoMetaData] = useState({
    loaded: false,
    duration: null,
  });
  const [videoSrc, setVideoSrc] = useState(null);
  const [selectedChart, setSelectedChart] = useState(props.angles[0]);
  const onMetaDataLoaded = (e) => {
    setVideoMetaData({ loaded: true, duration: e.target.duration });
  };
  useEffect(() => {
    let cancelled = false;
    setVideoSrc(null);
    getTrialVideos(props.trial_id).then((src) => {
      if (!cancelled && typeof src === "string" && src) setVideoSrc(src);
    });
    return () => {
      cancelled = true;
    };
  }, [props.trial_id]);
  return (
    <div>
      <span>{props.trial_id}</span>
      <div className="video-chart-container">
        <video controls onLoadedMetadata={onMetaDataLoaded}>
          {videoSrc ? <source src={videoSrc} type="video/mp4"></source> : null}
        </video>
        <div style={{width:'50%'}}>
          <Select
            onChange={(e)=>setSelectedChart(e.value)}
            defaultValue={
              props.angles.map((el) => ({ label: el, value: el }))[0]
            }
            options={props.angles.map((el) => ({ label: el, value: el }))}
          />
          {videoMetaData.loaded &&
            props.angles.map((el) => (
              <DisplayChartv2
                isSelected = {selectedChart==el}
                video_duration={videoMetaData.duration}
                trial_id={props.trial_id}
                name={el}
              />
            ))}
        </div>
      </div>
    </div>
  );
}

export default VideoChartContainer;
